import { formattedUserDetails } from "queries/identity.utils";
import { QueryFunctionContext } from "react-query";
import { JwtClient } from "utils/jwtClient";

type Token = {
  access_token: string;
  expires_in: number;
  id_token: string;
  refresh_token: string;
  token_type: string;
};

export const getOauthTokens = async (params: string): Promise<Token> => {
  const response = await fetch(
    `${process.env.REACT_APP_API_BASE_URL}/identity/oauth/token${params}`,
    { method: "POST" },
  );
  return await response.json();
};

export const getUserDetails = async ({
  queryKey,
}: QueryFunctionContext<
  [string, { userId: string; jwtClient: JwtClient }]
>): Promise<UserDetails> => {
  const [_key, { userId, jwtClient }] = queryKey;
  const response = await jwtClient.apiCall({
    path: "/identity/user_details",
    queryParams: {
      id: userId,
    },
  });

  const data = await response.json();

  return formattedUserDetails(data);
};

export type UpdatePasswordProps = {
  jwtClient: JwtClient;
  userId: string;
  params: {
    confirmPassword: string;
    currentPassword: string;
    newPassword: string;
  };
};

export async function updatePassword({
  jwtClient,
  userId,
  params: { confirmPassword, currentPassword, newPassword },
}: UpdatePasswordProps) {
  await jwtClient.apiCall({
    path: `/identity/passwords`,
    queryParams: {
      id: userId,
      current_password: currentPassword,
      password: newPassword,
      password_confirmation: confirmPassword,
    },
    fetchParams: {
      method: "PUT",
    },
  });
}

export type UpdateUserDetailsProps = {
  email?: string;
  jwtClient: JwtClient;
  preferredName?: string;
  userId: string;
};

export const updateUserDetails = async ({
  email,
  jwtClient,
  preferredName,
  userId,
}: UpdateUserDetailsProps): Promise<UpdateUserResponse> => {
  const response = await jwtClient.apiCall({
    path: `/identity/user_details`,
    queryParams: {
      ...(email && { email }),
      id: userId,
      ...(preferredName && { preferred_name: preferredName }),
    },
    fetchParams: {
      method: "PUT",
    },
  });
  const { data } = await response.json();
  return data;
};
